export default {
  title: 'Auto and home insurance',
  text: 'Save an average of $510 by bundling your auto and home insurance.',
  link: 'Get a quote',
  closeButton: 'Close',
  lobAlt: 'line of business icon',
};
